import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { updateUserDetailsRequest } from '../../common/features/user/userActions';
import { ReactComponent as CancelIcon } from '../../common/assets/svg/cancelIconnew.svg';
import { ReactComponent as VerifiedIcon } from '../../common/assets/svg/save.svg';
import DialCodePicker, { CountryCodeData } from '../dialCodePicker';
import { getCountryData } from '../../common/utils/country-data-util';
import countrycodedropdown from '../../common/assets/svg/dropdowncountrycode.svg';
import { deleteCookie, getCookie } from "../../helper/cookieHelper";
import { ACCESS_TOKEN, USER_DETAILS, USER_ID } from "../../common/constants";

const emailDomains = ['.com', '@gmail.com', '@outlook.com', '@icloud.com', '@yahoo.com'];

const UpdateUserDetails = ({
  onClose,
  countryData,
  data,
  isMobile,
  signInPopupDesktop,
  setCurrentPage,
}: any) => {
  const [emailDomain, setEmailDomain] = useState('');
  const [isCustomDomain, setIsCustomDomain] = useState(false);
  const userData = useSelector((state: any) => state.auth.userData);
  const dispatch = useDispatch();
  const customerDetails = getCookie(USER_DETAILS) || {};

  const customerId = getCookie(USER_ID) || "";
  const customeremail = customerDetails?.email || '';
  const customerName = customerDetails?.firstName || customerDetails?.name || '';
  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);
  const [showDialCodePicker, setShowDialCodePicker] = useState(false);
  const [countrySelected, setCountrySelected] = useState<any>(false);
  const [countryDataNew, setCountryData] = useState<CountryCodeData>(
    getCountryData(countryData ? countryData : '', restaurantDetails.country)
  );
  console.log({ countryDataNew });

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      mobile: '',
      firstName: '',
      lastName: '',
      email: '',
    },
  });
  const firstName = watch('firstName');
  const lastName = watch('lastName');
  const email = watch('email');
  const customerNumber = customerDetails?.mobilePhone;

  useEffect(() => {
    if (customerName) {
      setValue('firstName', customerName);
    }
    if (
      customeremail ||
      (restaurantDetails?.platformConfiguration?.sendOtpViaEmail && data?.inputData)
    ) {
      if (restaurantDetails?.platformConfiguration?.sendOtpViaEmail) {
        setValue('email', data?.inputData || customeremail);
      } else {
        setValue('email', customeremail);
      }
    }
    if (customerNumber) {
      setValue('mobile', customerNumber.split('-')[1]);
    }
  }, []);

  const handleEmailChange = (value: string) => {
    // Extract just the part before any @ or . if present
    let cleanEmail = value;
    setValue('email', cleanEmail);
  };

  const handleEmailDomainChange = (domain: string) => {
    if (domain) {
      setIsCustomDomain(false);
      setEmailDomain(domain);
      let tempEmail = email || '';
      if (domain.includes('@')) {
        if (tempEmail.includes('.')) tempEmail = tempEmail.split('.')[0];
        if (tempEmail.includes('@')) tempEmail = tempEmail.split('@')[0];
      } else if (domain === '.com') {
        if (tempEmail.includes('.')) tempEmail = tempEmail.split('.')[0];
      }
      tempEmail = tempEmail + domain;
      setValue('email', tempEmail);
    }
  };
  const emailOtp = false;
  const UpdateProfileSuccess = useSelector((state: any) => state.auth.UpdateProfileSuccess);
  const updateUserDetailsSuccess = useSelector((state: any) => state.user.updateUserDetailsSuccess);

  useEffect(() => {
    if (UpdateProfileSuccess || updateUserDetailsSuccess) {
      onClose();
    }
  }, [UpdateProfileSuccess, updateUserDetailsSuccess]);

  const updateUserDetailsuseddata: string = useSelector(
    (state: any) => state.user.usedMobileorEmail
  );
  const watchedemail = watch('email');

  const watchedponenumber = watch('mobile');
  const UpdateProfileErrorMessage = useSelector(
    (state: any) => state.auth.UpdateProfileErrorMessage
  );

  console.log({ updateUserDetailsuseddata, watchedponenumber, UpdateProfileErrorMessage });

  const onSubmit = (formData: any) => {
    // Do not proceed if there are form validation errors
    if (errors?.firstName || errors?.lastName || errors?.mobile || errors?.email) {
      return;
    }

    // Block API call if current input matches a prior "linked" error condition
    const isMobileLinkedError =
      restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
      UpdateProfileErrorMessage !== '' &&
      UpdateProfileErrorMessage?.includes('linked') &&
      updateUserDetailsuseddata === countryDataNew?.code + '-' + watchedponenumber;

    const isEmailLinkedError =
      !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
      UpdateProfileErrorMessage !== '' &&
      updateUserDetailsuseddata === watchedemail &&
      UpdateProfileErrorMessage?.includes('linked');

    if (isMobileLinkedError || isEmailLinkedError) {
      return;
    }

    // Get customerId from userData
    const customerId = userData?.customerId;

    const payload = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      email: formData.email,
      mobilePhone: countryDataNew?.code + '-' + formData.mobile,
      customerId,
      sendOtpViaEmail: restaurantDetails?.platformConfiguration?.sendOtpViaEmail,
    };

    // Dispatch action to update user details
    dispatch(updateUserDetailsRequest(payload));
  };

  return (
    <>
      {
        isMobile &&(
        <button className={
          isMobile ? 
          restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? 
          UpdateProfileErrorMessage?.includes('linked') ? 
          'close-btnZa-signup-emailotp-updateEror' : 
          "close-btnZa-signup-emailotp" : 
          "close-btnZa-signup" : 
          "close-btn-otpscreen-desktop"
        }

          onClick={() => onClose()}>
          {/* <img src={cancelIcon} alt="" /> */}
          <CancelIcon
            className="signInCancel-btn"
            onClick={() =>{ onClose()
                deleteCookie(USER_ID);
                deleteCookie(USER_DETAILS);
                deleteCookie(ACCESS_TOKEN);
            }
            }
          />
        </button>
      )}

      <div className={isMobile ? 'signup-mobile-container' : 'signup-mobile-container-D'}>
        <div className={isMobile ? 'signup-mobile-card' : 'signup-mobile-card-D'}>
          {(isMobile || signInPopupDesktop) && (
            <h1 className="signup-mobile-card-title">Sign Up</h1>
          )}

          <p
            className={
              isMobile
                ? 'otp-subtitle'
                : signInPopupDesktop
                ? 'otp-subtitle-D-popup'
                : 'signup-subtitle-D'
            }
          >
            <span
              className={
                isMobile
                  ? 'otp-subtitle-text'
                  : signInPopupDesktop
                  ? 'otp-subtitle-text-D-popup'
                  : 'otp-subtitle-text-D'
              }
            >
              Welcome, New user. Please enter your details to proceed.
            </span>
            {isMobile ? (
              <>
                <span
                  className={
                    isMobile ? 'otp-subtitle-text-phoneNumber' : 'otp-subtitle-text-phoneNumber-D'
                  }
                  style={{ color: '#E31837' }}
                >
                  {data?.inputData}
                </span>
                <span
                  className={isMobile ? 'otp-subtitle-text-change' : 'otp-subtitle-text-change'}
                  onClick={() => {
                    setCurrentPage('signin');
                  }}
                >
                  Change
                </span>
              </>
            ) : (
              <></>
            )}
          </p>

          <form
            onSubmit={handleSubmit(onSubmit)}
            className={isMobile ? 'signup-form-conatiner' : 'signup-form-conatiner-D'}
          >
            <div className="form-group">
              <label className={isMobile ? 'form-label-M' : 'form-label'}>
                Mobile Number<span className="input-asterisk">*</span>
              </label>
              <div
                className={isMobile ? 'phone-input-container' : 'signup-mobile-input'}
                style={{
                  border:
                    restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                    UpdateProfileErrorMessage !== '' &&
                    UpdateProfileErrorMessage?.includes('linked') &&
                    updateUserDetailsuseddata === countryDataNew?.code + '-' + watchedponenumber
                      ? '1px solid #e52333'
                      : undefined,
                  color:
                    restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                    UpdateProfileErrorMessage !== '' &&
                    UpdateProfileErrorMessage?.includes('linked') &&
                    updateUserDetailsuseddata === countryDataNew?.code + '-' + watchedponenumber
                      ? '#e52333'
                      : undefined,
                }}
              >
                <div
                  className="country-code"
                  onClick={() => {
                    setShowDialCodePicker(!showDialCodePicker);
                    setCountrySelected(!countrySelected);
                  }}
                >
                  <span className="flag">
                    <img className="flag" src={countryDataNew.flag} alt="flag" />
                  </span>
                  <img src={countrycodedropdown} alt="" className="dropdown-icon-Desktop-signup" />
                  <span style={{ color: '#707070' }}>{countryDataNew.code}</span>
                </div>
                <span className="divider-Desktop-signup" />
                <input
                  type="text"
                  className="phone-input"
                  maxLength={10}
                  disabled={!restaurantDetails?.platformConfiguration?.sendOtpViaEmail}
                  style={{
                    color:
                      restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                      UpdateProfileErrorMessage !== '' &&
                      UpdateProfileErrorMessage?.includes('linked') &&
                      updateUserDetailsuseddata === countryDataNew?.code + '-' + watchedponenumber
                        ? '#e52333'
                        : undefined,
                  }}
                  onKeyDown={e => {
                    if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
                      e.preventDefault();
                    }
                  }}
                  {...register('mobile', {
                    required: 'Mobile number is required',
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: 'Enter a valid 10-digit mobile number',
                    },
                  })}
                />
                {!restaurantDetails?.platformConfiguration?.sendOtpViaEmail && (
                  <div className="verified-icon">
                    <VerifiedIcon style={{ color: 'green' }} />
                  </div>
                )}
              </div>
              <div className="dialCode">
                <DialCodePicker
                  showPicker={showDialCodePicker}
                  setShowPicker={setShowDialCodePicker}
                  setCountrySelected={setCountrySelected}
                  setCountryData={setCountryData}
                  inputValue=""
                  countryCode={customerNumber?.split('-')[0]}
                  setIsMobile={true}
                  onlyMobile={true}
                  isMobileNot={true}
                  // width="50%"
                  height="32vh"
                  top="76px"
                />
              </div>
              {errors.mobile && (
                <span className="error-message">{errors.mobile.message as string}</span>
              )}
              {restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                UpdateProfileErrorMessage !== '' &&
                UpdateProfileErrorMessage?.includes('linked') &&
                updateUserDetailsuseddata === countryDataNew?.code + '-' + watchedponenumber && (
                  <span className="error-message">{UpdateProfileErrorMessage}</span>
                )}
            </div>

            <div className={isMobile ? 'form-row-M' : 'form-row-D'}>
              <div
                className={`${isMobile ? 'form-group' : 'form-input-mobile-container-names'} ${
                  isMobile && 'half-width'
                }`}
              >
                <label className={isMobile ? 'form-label-M' : 'form-label'}>
                  First Name<span className="input-asterisk">*</span>
                </label>
                <input
                  type="text"
                  className={isMobile ? 'form-input-mobile-firtsname' : 'form-input-D-firtsname'}
                  placeholder=""
                  maxLength={32}
                  autoComplete="new-password"
                  inputMode="text"
                  onPaste={e => {
                    const pastedText = e.clipboardData.getData('text');
                    if (!/^[a-zA-Z]+$/.test(pastedText)) {
                      e.preventDefault();
                    }
                  }}
                  onInput={e => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/[^a-zA-Z]/g, '');
                  }}
                  onKeyDown={e => {
                    const key = e.key;
                    if (key.length > 1 || /^[a-zA-Z]$/.test(key)) {
                      return;
                    }
                    e.preventDefault();
                  }}
                  {...register('firstName', {
                    required: 'First name is required',
                    pattern: {
                      value: /^[A-Za-z ]+$/,
                      message: 'Only alphabets allowed',
                    },
                  })}
                />
                {errors.firstName && (
                  <span className="error-message">{errors.firstName.message as string}</span>
                )}
              </div>

              <div
                className={`${isMobile ? 'form-group' : 'form-input-mobile-container-names'} ${
                  isMobile && 'half-width'
                }`}
              >
                <label className={isMobile ? 'form-label-M' : 'form-label'}>Last Name</label>
                <input
                  type="text"
                  className={isMobile ? 'form-input-mobile-lastname' : 'form-input-D-lastname'}
                  placeholder=""
                  maxLength={32}
                  autoComplete="new-password"
                  inputMode="text"
                  onPaste={e => {
                    const pastedText = e.clipboardData.getData('text');
                    if (!/^[a-zA-Z]+$/.test(pastedText)) {
                      e.preventDefault();
                    }
                  }}
                  onInput={e => {
                    const input = e.target as HTMLInputElement;
                    input.value = input.value.replace(/[^a-zA-Z]/g, '');
                  }}
                  onKeyDown={e => {
                    const key = e.key;
                    if (key.length > 1 || /^[a-zA-Z]$/.test(key)) {
                      return;
                    }
                    e.preventDefault();
                  }}
                  {...register('lastName', {
                    pattern: {
                      value: /^[A-Za-z ]+$/,
                      message: 'Only alphabets allowed',
                    },
                  })}
                />
              </div>
            </div>

            <div className="form-group">
              <label className={isMobile ? 'form-label-M' : 'form-label'}>
                Email<span className="input-asterisk">*</span>
              </label>
              <div className="email-input-container">
                <input
                  type="text"
                  maxLength={32}
                  className={isMobile ? 'email-prefix' : 'email-prefix-mobile-D'}
                  autoComplete="new-password"
                  inputMode="text"
                  readOnly={restaurantDetails?.platformConfiguration?.sendOtpViaEmail}
                  style={{
                    border:
                      !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                      UpdateProfileErrorMessage !== '' &&
                      updateUserDetailsuseddata === watchedemail &&
                      UpdateProfileErrorMessage?.includes('linked')
                        ? '1px solid #e52333'
                        : undefined,
                    color:
                      !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                      UpdateProfileErrorMessage !== '' &&
                      updateUserDetailsuseddata === watchedemail &&
                      UpdateProfileErrorMessage?.includes('linked')
                        ? '#e52333'
                        : undefined,
                  }}
                  onPaste={e => {
                    const pastedText = e.clipboardData.getData('text');
                    if (!/^[a-zA-Z0-9@._%+-]$/.test(pastedText)) {
                      e.preventDefault();
                    }
                  }}
                  onKeyDown={e => {
                    const key = e.key;
                    if (
                      key === 'Backspace' ||
                      key === 'Delete' ||
                      key === 'ArrowLeft' ||
                      key === 'ArrowRight' ||
                      key === 'Tab'
                    ) {
                      return;
                    }
                    const allowedChars = /^[a-zA-Z0-9@._%+-]$/;
                    if (!allowedChars.test(key)) {
                      e.preventDefault();
                    }
                  }}
                  placeholder=""
                  {...register('email', {
                    required: 'Email is required',
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: 'Enter a valid email',
                    },
                  })}
                  onChange={e => handleEmailChange(e.target.value)}
                />
                {errors.email && (
                  <span className="error-message">{errors.email.message as string}</span>
                )}
                {!restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                  UpdateProfileErrorMessage !== '' &&
                  updateUserDetailsuseddata === watchedemail &&
                  UpdateProfileErrorMessage?.includes('linked') && (
                    <span className="error-message">{UpdateProfileErrorMessage}</span>
                  )}
              </div>
              {!restaurantDetails?.platformConfiguration?.sendOtpViaEmail && (
                <div className="email-domain-options">
                  {emailDomains?.map((domain: any) => (
                    <button
                      type="button"
                      className={emailDomain === domain ? 'domain-option active' : 'domain-option'}
                      key={domain}
                      onClick={() => handleEmailDomainChange(domain)}
                    >
                      {domain}
                    </button>
                  ))}
                </div>
              )}
            </div>

            {isMobile ? (
              <button type="submit" className="continue-button-M">
                Continue
              </button>
            ) : (
              <div className="button-group-Desktop-signup">
                <button
                  type="button"
                  className="cancel-btn-Desktop-signup"
                  onClick={() => {
                    setCurrentPage('signin');
                  }}
                >
                  Change
                </button>
                <button type="submit" className="submit-btn-Desktop-signup">
                  Continue
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </>
  );
};

export default UpdateUserDetails;
